import React from 'react';
import { SectionLink } from './SectionLink';

/**
 * Allergen-conscious callout — quiet and findable, not loud (Jarvis, 2026-08-11).
 *
 * The honest framing: TrueNooch is vegan, so the four animal allergens (milk, egg,
 * fish, shellfish) are absent by definition — nothing to prop up, and Jarvis's call is
 * to NOT list them. What we show is the FIVE PLANT allergens that nearly every plant
 * protein is actually built on (soy, wheat, tree nuts, peanuts, sesame) — TrueNooch is
 * made from none of them. The "nine" is carried in the words (heading + note), so the
 * full claim still reads without listing the vegan-trivial four.
 *
 * The claim is the specific, defined "nine major U.S. food allergens" — never a blanket
 * "allergen-free" / "hypoallergenic": the base is pre-facility (no certification), it is
 * legume-based (legumes are an allergen for some), and ingredient-truth is what stays
 * true under scrutiny.
 */

// Each pill is self-contained "-free" — never a bare allergen name. A gold tag
// reading just "Soy" on an allergen page reads like a CONTAINS badge, i.e. the
// exact opposite of the truth. "when we say soy, we say soy-free" (Jarvis).
const INTENTIONAL = ['Soy-free', 'Wheat-free', 'Tree-nut-free', 'Peanut-free', 'Sesame-free'];

export function AllergenConscious() {
  return (
    <section
      className="section fade-in allergen"
      style={{ paddingTop: '2rem', paddingBottom: '2rem' }}
    >
      <div className="section-label">Allergen-conscious</div>
      <h2>Made without any of the nine</h2>
      <p className="allergen-lede">
        Most plant proteins are built on soy, wheat, or nuts. TrueNooch&trade; is built on
        none of them.
      </p>

      <div className="allergen-group">
        <div className="allergen-group-label">The ones that take intention</div>
        <div className="allergen-pills">
          {INTENTIONAL.map((a) => (
            <span key={a} className="allergen-pill">
              {a}
            </span>
          ))}
        </div>
      </div>

      <p className="allergen-note">
        None of the nine major U.S. food allergens. Small-batch and made by hand.
      </p>

      <SectionLink to="/nutrition">What’s inside</SectionLink>
    </section>
  );
}
